import { merge } from './helpers.mjs';
import { setVueInstance, setOptions, Programmatic, getOptions } from './config.mjs';
export { Plugin as Config, Programmatic as ConfigProgrammatic } from './config.mjs';
import { r as registerPlugin, a as registerComponentProgrammatic, u as use } from './plugins-9401a4a3.mjs';
export { _ as OIcon } from './Icon-33c4eb50.mjs';
import './FormElementMixin-8a82acd9.mjs';
export { _ as OInput } from './Input-c4d580b8.mjs';
export { _ as OAutocomplete } from './Autocomplete-e4ac9dbb.mjs';
import Plugin from './autocomplete.mjs';
export { default as Autocomplete } from './autocomplete.mjs';
export { _ as OButton } from './Button-531a1501.mjs';
import Plugin$1 from './button.mjs';
export { default as Button } from './button.mjs';
import './InjectedChildMixin-02a6a608.mjs';
import Plugin$2 from './carousel.mjs';
export { default as Carousel, OCarousel, OCarouselItem } from './carousel.mjs';
import './CheckRadioMixin-5804b41c.mjs';
export { _ as OCheckbox } from './Checkbox-3a607f3f.mjs';
import Plugin$3 from './checkbox.mjs';
export { default as Checkbox } from './checkbox.mjs';
import Plugin$4 from './collapse.mjs';
export { default as Collapse, OCollapse } from './collapse.mjs';
import './MatchMediaMixin-98548268.mjs';
import './trapFocus-21978f6e.mjs';
export { _ as ODropdown, a as ODropdownItem } from './DropdownItem-7f1679bc.mjs';
export { _ as OSelect } from './Select-504292c7.mjs';
export { _ as ODatepicker } from './Datepicker-4c16c364.mjs';
import Plugin$5 from './datepicker.mjs';
export { default as Datepicker } from './datepicker.mjs';
export { _ as BTimepicker } from './Timepicker-b816548e.mjs';
import Plugin$6 from './datetimepicker.mjs';
export { BDatetimepicker, default as Datetimepicker } from './datetimepicker.mjs';
import Plugin$7 from './dropdown.mjs';
export { default as Dropdown } from './dropdown.mjs';
export { _ as OField } from './Field-95d1600d.mjs';
import Plugin$8 from './field.mjs';
export { default as Field } from './field.mjs';
import Plugin$9 from './icon.mjs';
export { default as Icon } from './icon.mjs';
import Plugin$a from './input.mjs';
export { default as Input } from './input.mjs';
import Plugin$b from './inputitems.mjs';
export { default as Inputitems, OInputitems } from './inputitems.mjs';
import './ssr-acde8f04.mjs';
export { _ as OLoading } from './Loading-8282bd81.mjs';
import './InstanceRegistry-4ed35c20.mjs';
import Plugin$c from './loading.mjs';
export { default as Loading, LoadingProgrammatic } from './loading.mjs';
import Plugin$f from './notification.mjs';
export { default as Notification, default as NotificationNotice, NotificationProgrammatic, ONotification } from './notification.mjs';
import Plugin$d from './modal.mjs';
export { default as Modal, ModalProgrammatic, OModal } from './modal.mjs';
import Plugin$e from './menu.mjs';
export { default as Menu, OMenu, OMenuItem, OMenuList } from './menu.mjs';
export { _ as OPagination, a as OPaginationButton } from './Pagination-e72adb39.mjs';
import Plugin$g from './pagination.mjs';
export { default as Pagination } from './pagination.mjs';
import Plugin$h from './radio.mjs';
export { ORadio, default as Radio } from './radio.mjs';
import Plugin$i from './select.mjs';
export { default as Select } from './select.mjs';
import Plugin$j from './skeleton.mjs';
export { OSkeleton, default as Skeleton } from './skeleton.mjs';
import Plugin$k from './sidebar.mjs';
export { OSidebar, default as Sidebar } from './sidebar.mjs';
export { _ as OTooltip } from './Tooltip-6590c559.mjs';
import Plugin$l from './slider.mjs';
export { OSlider, OSliderTick, default as Slider } from './slider.mjs';
import './SlotComponent-1b1e66c6.mjs';
import './TabbedChildMixin-f9fc33fb.mjs';
import Plugin$m from './steps.mjs';
export { OStepItem, OSteps, default as Steps } from './steps.mjs';
import Plugin$n from './switch.mjs';
export { OSwitch, default as Switch } from './switch.mjs';
import Plugin$o from './table.mjs';
export { OTable, OTableColumn, default as Table } from './table.mjs';
import Plugin$p from './tabs.mjs';
export { OTabItem, OTabs, default as Tabs } from './tabs.mjs';
import Plugin$q from './timepicker.mjs';
export { default as Timepicker } from './timepicker.mjs';
import Plugin$r from './tooltip.mjs';
export { default as Tooltip } from './tooltip.mjs';
import Plugin$s from './upload.mjs';
export { OUpload, default as Upload } from './upload.mjs';

var plugins = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Autocomplete: Plugin,
    Button: Plugin$1,
    Carousel: Plugin$2,
    Checkbox: Plugin$3,
    Collapse: Plugin$4,
    Datepicker: Plugin$5,
    Datetimepicker: Plugin$6,
    Dropdown: Plugin$7,
    Field: Plugin$8,
    Icon: Plugin$9,
    Input: Plugin$a,
    Inputitems: Plugin$b,
    Loading: Plugin$c,
    Modal: Plugin$d,
    Menu: Plugin$e,
    Notification: Plugin$f,
    NotificationNotice: Plugin$f,
    Pagination: Plugin$g,
    Radio: Plugin$h,
    Select: Plugin$i,
    Skeleton: Plugin$j,
    Sidebar: Plugin$k,
    Slider: Plugin$l,
    Steps: Plugin$m,
    Switch: Plugin$n,
    Table: Plugin$o,
    Tabs: Plugin$p,
    Timepicker: Plugin$q,
    Tooltip: Plugin$r,
    Upload: Plugin$s
});

const Oruga = {
  install(Vue, options = {}) {
    setVueInstance(Vue); // Options

    const defaultConfig = getOptions();
    setOptions(merge(defaultConfig, options, true)); // Components

    for (const componentKey in plugins) {
      registerPlugin(Vue, plugins[componentKey]);
    } // Config component


    registerComponentProgrammatic(Vue, 'config', Programmatic);
  }

};
use(Oruga);

export default Oruga;
